import PropTypes from 'prop-types';
import React from 'react';
import '../../styles/messagePane.scss';
import File from '../../svgIcons/dist/components/file';
import Send from '../../svgIcons/dist/components/send';
import Smiley from '../../svgIcons/dist/components/smiley';

class MessagePaneButtons extends React.Component {

  handleFileSelect(e) {
    const file = e.target.files[0];
    if (file) {
      this.props.onFileSelect(file);
    }
  }

  render() {

    return (
      <span className="message-pane-buttons">
        {this.props.shouldShowEmojiButton ? <button className="emoji-button" onClick={this.props.handleEmojiPaneToggle}><Smiley size="18px"/></button> : null}
        <button className={`send-button ${this.props.shouldShowSend ? '' : 'hide-button'}`} onClick={e => this.props.handleSend(e)}><Send size="16px"/></button>
        {this.props.shouldShowAttachmentButton ?
          <span className={`file-button ${this.props.shouldShowSend ? 'hide-button' : ''}`} onClick={this.props.onAttachmentClick}>
            <File id="attachments-button" size="17px"/>
            <input
              aria-labelledby="attachments-button"
              type="file"
              accept=".xlsx,.xls, image/*,.doc, .docx, .ppt, .pptx, .pdf"
              onChange={e => this.handleFileSelect(e)}
              className="file-upload-input"
              />
          </span> :
          null
        }
      </span>
    );
  }
}

MessagePaneButtons.propTypes = {
  handleEmojiPaneToggle: PropTypes.func,
  onAttachmentClick: PropTypes.func,
  handleSend: PropTypes.func,
  onFileSelect: PropTypes.func,
  shouldShowSend: PropTypes.bool,
  shouldShowEmojiButton: PropTypes.bool,
  shouldShowAttachmentButton: PropTypes.bool
};

export default MessagePaneButtons;



// WEBPACK FOOTER //
// ./chat-app/components/MessagePaneButtons/MessagePaneButtons.js